import { Avatar, Link, Typography } from '@mui/material';
import { CustomMetaTitle } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useIsDesktop } from 'Hooks';
import { SuccessRequest } from 'Images';
import { useNavigate } from 'react-router-dom';

interface IProps {
  tabValue: number;
}
export const SuccessHeaderContent = ({ tabValue }: IProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];
  const navigate = useNavigate();

  const otpData = useAppSelector(
    ({ otpLoginDetails: { otpLoginDetails } }) => otpLoginDetails,
  );

  return (
    <>
      <CustomMetaTitle
        title={`${dictionary.title} - ${dictionary.successDialog.title}`}
        disablePrefix
      />
      {otpData && otpData.email && tabValue === 0 && (
        <Typography
          sx={{
            mb: isDesktop ? '28px' : '14px',
            fontSize: isDesktop ? '28px' : '20px',
            textAlign: 'center',
          }}
        >
          {dictionary.successDialog.headerTitle1}
        </Typography>
      )}
      <Typography
        variant='h4'
        component='p'
        sx={{
          mb: isDesktop ? '28px' : '24px',
          textAlign: 'center',
        }}
      >
        {otpData
          ? dictionary.successDialog.headerTitle2
          : dictionary.successDialog.headerTitleOTP}
        <Link
          onClick={() => navigate(dictionary.successDialog.headerTitleUrl)}
          sx={{
            mr: 1,
            textDecoration: 'underline',
          }}
        >
          {otpData
            ? dictionary.successDialog.headerTitleUrlLabel
            : dictionary.successDialog.headerTitleUrlLabelOTP}
        </Link>
      </Typography>
      <Avatar
        src={SuccessRequest}
        alt={''}
        sx={{
          width: '200px',
          height: '183px',
          mb: 8,
          alignSelf: 'center',
        }}
      />
    </>
  );
};
